import { Navigate } from "react-router-dom";
import { getAccessToken, getLoginType } from "../services/auth";
import { USER_ROLES } from "./userRoles";

const ROLE_HOME_PATHS = {
  [USER_ROLES.SUPER_ADMIN]: "/admin-dashboard",
  [USER_ROLES.HEALTH_PROFESSIONAL]: "/hp-dashboard",
};

const getStoredLoginType = () => {
  const loginType = getLoginType();

  if (loginType) {
    return String(loginType);
  }

  try {
    const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");

    return userData.loginType ? String(userData.loginType) : null;
  } catch {
    return null;
  }
};

const normalizeRoles = (allowedRoles) => {
  if (!allowedRoles) {
    return [];
  }

  return Array.isArray(allowedRoles)
    ? allowedRoles.map(String)
    : [String(allowedRoles)];
};

const ProtectedRoute = ({ children, allowedRoles, redirectTo = "/" }) => {
  const token = getAccessToken();
  const loginType = getStoredLoginType();
  const allowedRoleList = normalizeRoles(allowedRoles);

  if (!token) {
    return <Navigate to={redirectTo} replace />;
  }

  if (allowedRoleList.length > 0 && !allowedRoleList.includes(loginType)) {
    const roleHomePath = ROLE_HOME_PATHS[loginType] || redirectTo;

    return <Navigate to={roleHomePath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

export const SignInRoute = ({ children }) => {
  const token = getAccessToken();
  const loginType = getStoredLoginType();

  if (token) {
    const roleHomePath = ROLE_HOME_PATHS[loginType];

    if (roleHomePath) {
      return <Navigate to={roleHomePath} replace />;
    }
  }

  return <>{children}</>;
};
